import FormInputValidation from './FormInputValidation';

interface FormInputProps {
    id: string;
    type: string;
    name: string;
    label: string;
    validation: any;
    multiline?: boolean;
    placeholder: string;
    labelClass?: string;
    labelColor?: string;
    wrapperClass?: string;
    inputClass?: string;
}

const FormInput: React.FC<FormInputProps> = ({
    id,
    name,
    type,
    label,
    validation,
    multiline,
    placeholder,
    labelClass,
    labelColor,
    wrapperClass,
    inputClass,
}) => {
    return (
        <FormInputValidation
            id={id}
            name={name}
            type={type}
            label={label}
            multiline={multiline}
            validation={validation}
            placeholder={placeholder}
            labelClass={labelClass}
            labelColor={labelColor}
            wrapperClass={wrapperClass || "mb-6 space-y-1.5"}
            inputClass={inputClass || ""}
        />
    )
}

export default FormInput;
